var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3909 6.72314C29.6461 5.97794 28.7617 5.38679 27.7883 4.98347C26.815 4.58015 25.7717 4.37256 24.718 4.37256C23.6644 4.37256 22.6211 4.58015 21.6477 4.98347C20.6743 5.38679 19.79 5.97794 19.0451 6.72314L17.4993 8.26897L15.9534 6.72314C14.4489 5.21859 12.4083 4.37334 10.2805 4.37334C8.15277 4.37334 6.11216 5.21859 4.60761 6.72314C3.10306 8.22769 2.25781 10.2683 2.25781 12.3961C2.25781 14.5238 3.10306 16.5644 4.60761 18.069L17.4993 30.9606L30.3909 18.069C31.1361 17.3241 31.7273 16.4397 32.1306 15.4664C32.5339 14.493 32.7415 13.4497 32.7415 12.3961C32.7415 11.3424 32.5339 10.2991 32.1306 9.32574C31.7273 8.35237 31.1361 7.46799 30.3909 6.72314Z",
    stroke: "#1E1E1E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartDefault);
export default __webpack_public_path__ + "static/media/heart-default.2011ac2448008de8a07b3f051da6aca9.svg";
export { ForwardRef as ReactComponent };